import SideHustle from '@/pages/SideHustle'

export default {
  path: '/sidehustle',
  name: 'SideHustle',
  component: SideHustle
}



// WEBPACK FOOTER //
// ./src/router/sidehustle.js